import { usePopupStore } from '../../../store/index.js';
import type { Props } from './types.js';
import { DataSTag, Sel } from '#~/stag/index.js';
import * as Popover from '@studio/design-system/popover';
import { shortCircuit } from '@studio/react-utils/event';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';

/** `<Monitoring>` component. */
export const Monitoring = ({ children, className, disabled, ...props }: Props): ReactElement => {
  const { popup, setPopup } = usePopupStore();
  return (
    <Popover.Root
      open={disabled ? false : popup == 'monitoring'}
      onOpenChange={(open) => {
        setPopup(open ? 'monitoring' : false);
      }}
    >
      <Popover.Toggle disabled={disabled} icon='monitoring' {...props} />
      <Popover.Content
        // Open/closed state is read from this tag, not from the 'Monitoring'
        // header text. Per rule: playwright-stag-selectors-only (ai.knowledge/platform).
        {...DataSTag(Sel.Monitoring, 'panel')}
        className={twMerge('w-[582px] overflow-hidden z-50', className)}
        collisionPadding={16}
        onInteractOutside={shortCircuit}
        sideOffset={10}
      >
        <Popover.Header title='Monitoring' />
        {children}
        <Popover.Arrow />
      </Popover.Content>
    </Popover.Root>
  );
};

/** `<Monitor>` alias. */
export { Monitoring as Root };
